import { gql } from '@apollo/client'

export const GET_LLM_SETTINGS = gql`
  query GetLLMSettings {
    getLLMSettings {
      id
      model
      temperature
      updatedBy
      updatedAt
    }
  }
`

export const UPDATE_LLM_SETTINGS = gql`
  mutation UpdateLLMSettings($data: UpdateLLMSettingsInput!) {
    updateLLMSettings(data: $data) {
      id
      model
      temperature
      updatedBy
      updatedAt
    }
  }
`
